import { type FunctionalComponent, h } from '@stencil/core';
import { followUpActions, VIEW_REPLACEMENTS_FOR } from './follow-up-actions-helpers';
import type { ConversationalSearchRefinements } from '../../../../conversational-search-types/conversational-search-types.type';
import { ConversationalSearchLabelWithSection } from '../../../../conversational-search-partials/label-with-section/label-with-section';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import EventEmitterComponent from '../../../../conversational-search-partials/event-emitter-component/event-emitter-component';

export interface IConversationalSearchFollowUpActions {
  query: string;
  labelProvider: labelProviderInterface;
  conversationalSearchBrandUrl: string;
  country: string;
  language: string;
  refineCallback: Function;
  feedbackCallback: Function;
  substitutionProductsIds: string[];
  refinementData: ConversationalSearchRefinements;
}

export const ConversationalSearchFollowUpActions: FunctionalComponent<
  IConversationalSearchFollowUpActions
> = (props) => {
    const elements = followUpActions(props, [
      'characteristicsAction',
      'substitutionAction',
      'feedbackAction'
    ]);

    if (!elements?.length) return;

    const renderText = (item) => {
        return item.action === VIEW_REPLACEMENTS_FOR && item.productIdsString ? (
          <a href={item.redirectionUrl} target="_blank" onClick={() => item.callback()}>
            <ConversationalSearchLabelWithSection
              text={item.text}
              partial={item.productIdsString}
            />
          </a>
        ) : (
          <button onClick={() => item.callback()}>
            {item.text}
          </button>
        );
    };

    return (
      <section class="conversational-search-message-follow-up-actions">
        <span class="conversational-search-message-follow-up-actions__header">
          {props.labelProvider(
            'conversational.search.follow.up.into',
            'You may also want to...',
          )}
        </span>
        <section class="conversational-search-message-follow-up-actions__cta">
          {elements.map((item) => {
              const suggestionName = item?.productIdsString ? item.action?.replace('{0}', item.productIdsString) : item.action;
              return <div>
                <EventEmitterComponent
                  eventName='conversational-search:ga-suggestion'
                  suggestionName={suggestionName}
                  keyword={props.query}
                  category='User Response'
                  url={item?.redirectionUrl}
                >
                  {renderText(item)}
                </EventEmitterComponent>
              </div>;
          })}
        </section>
      </section>
    );
};
